import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { publicPalette } from '../../Public/PublicLayout';

const Answer = ({ question, answer }) => (
  <Accordion
    disableGutters
    elevation={0}
    sx={{
      mb: 1.5,
      color: publicPalette.text,
      border: `1px solid ${publicPalette.border}`,
      borderRadius: '16px !important',
      backgroundColor: alpha('#FFFFFF', 0.03),
      overflow: 'hidden',
      '&:before': { display: 'none' },
      '&.Mui-expanded': { borderColor: alpha(publicPalette.primary, 0.4), backgroundColor: alpha(publicPalette.primary, 0.045) },
    }}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreRoundedIcon sx={{ color: publicPalette.primary }} />}
      sx={{ px: { xs: 2.25, sm: 3 }, py: 0.7, '& .MuiAccordionSummary-content': { my: 1.4 } }}
    >
      <Typography sx={{ pr: 2, color: publicPalette.text, fontSize: { xs: 16, sm: 18 }, fontWeight: 800 }}>{question}</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ px: { xs: 2.25, sm: 3 }, pb: 3, pt: 0 }}>
      <Typography sx={{ color: publicPalette.muted, lineHeight: 1.8, whiteSpace: 'pre-line' }}>{answer}</Typography>
    </AccordionDetails>
  </Accordion>
);

export default Answer;
